<template>
<div class="chapter">
<div class="inner_page">
<p class="indent5"><span aria-label="page 31" id="page_31" role="doc-pagebreak">Hailey stood next to Eva. “I’m sorry.”</span></p>
<p class="indent">Eva kept her gaze on the horizon. “There are warbots in the forest right now. I can <i>feel</i> the fear they’re causing the plants and animals. These warbots are searching for something.”</p>
<p class="indent">“You?”</p>
<p class="indent">“Yes, me.”</p>
<p class="indent">Though the facts were bleak, Eva somehow felt better sharing everything she knew with Hailey. It was as if a heavy burden had been lifted from her spirit.</p>
<p class="indent">Hailey put his arm around Eva. “Well, then, that’s all the more reason for us to leave. Loroc can’t find you if you’re not here.”</p>
<p class="indent">The mention of Loroc’s name brought forth his parting words to Eva: <i>I do not fall by your hand. You, however, shall fall by mine.</i></p>
<p class="indent">“He’ll find me.” Eva turned back toward the wandering tree. “It’s just a matter of time.” She hoisted herself up onto a branch and offered a hand to help Hailey. Both climbed up to the topmost bough, and the tree began moving.</p>
<p class="indent">As the wind tousled her hair, Eva watched the forest give way to a flat barren plain. Somewhere in the distance lay the wreckage of the <i>Bijou</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03_sub02.vue?658e30e1